import React, { useState, useEffect } from "react";
import axios from "axios";
import swal from "sweetalert";
import jwtDecode from "jwt-decode";
import { getToken } from "../../../api/token";
import { siteURL, cartLinkVerCarrito } from "../../../utils/constants";


export default function ContenidoCart() {
  
  const token = getToken();
  const iduser = jwtDecode(token).data.user.id;

  const [datosProductosCart, setProductosCart] = useState([]);
  const [subTotalG, setSubTotalG] = useState();
  
  

  const viewCart = async () => {
    //console.log(iduser)
    let link = `${siteURL}${cartLinkVerCarrito}get-cart?cart_key=${iduser}&thumb=true`;

    let config = {
      method: "get",
      url: link,
      headers: {},
    };

    axios(config)
      .then(function (response) {
        //console.log(response.data);
        return response.data;
      

      })
      .then((response) => {
        let cart = [response];

        let carrito = cart[0];

        let arrayProducts = [];

        cart.forEach((obj) => {
          Object.entries(obj).forEach(([clave, valor]) => {
            let price = carrito[clave]["regular_price"];
            let img = carrito[clave]["product_image"];
            let puntos = carrito[clave]["product_points"];
            let cantidad = carrito[clave]["quantity"];
            let total = carrito[clave]["line_total"];
            var nombre = carrito[clave]["product_name"];
            let nVProducto = carrito[clave]["variation_id"];
            let totalP = puntos * cantidad;
            let key = carrito[clave]["key"];


      
            let productElemente = {
              img: img,
              name: nombre,
              key: key,
              precio: price,
              puntos: puntos,
              cantidad: cantidad,
              valorVariable: nVProducto,
              total: total,
              totalPuntos: totalP,
            };

          

            return arrayProducts.push(productElemente);
          });
          
          setProductosCart([arrayProducts]);
        });
      })
      .catch((error) => console.error(error));

   
  };




const viewTotal = () =>{

  let link = `${siteURL}${cartLinkVerCarrito}totals?cart_key=${iduser}`;

      let config = {
        method: 'get',
        url: link,
        headers: { 
       }
      };
      
      axios(config)
      .then(function (response) {
        return response.data
        
      }).then(response=>{
       setSubTotalG(response.subtotal);
    })
      .catch(function (error) {
        console.log(error);
      });
}; 

  //console.log(datosProductosCart[0]);
  const verCarrito = datosProductosCart[0];

  const [form, setState] = useState({
    cantidades: "",
    cantidad0: "",
    cantidad1: "",
    cantidad2: "",
    cantidad3: "",
    cantidad4: "",
    cantidad5: "",
    cantidad6: "",
    cantidad7: "",
    cantidad8: "",
    cantidad9: "",
    cantidad10: "",
    cantidad11: "",
    cantidad12: "",
    cantidad13: "",
    cantidad14: "",
    cantidad15: "",
    cantidad16: "",
    cantidad17: "",
    cantidad18: "",
    cantidad20: "",
    cantidad21: "",
    cantidad22: "",
    cantidad23: "",
    cantidad24: "",
    cantidad25: "",
    cantidad26: "",
    cantidad27: "",
    cantidad28: "",
    cantidad29: "",
    cantidad30: "",
    cantidad31: "",
    cantidad32: "",
    cantidad33: "",
    cantidad34: "",
    cantidad35: "",
    cantidad36: "",
    cantidad37: "",
    cantidad38: "",
    cantidad39: "",
    cantidad40: "",
    cantidad41: "",
    cantidad42: "",
    cantidad43: "",
    cantidad44: "",
    cantidad45: "",
    cantidad46: "",
    cantidad47: "",
    cantidad48: "",
    cantidad49: "",
    cantidad50: "",
    cantidad51: "",
    cantidad52: "",
    cantidad53: "",
    cantidad54: "",
    cantidad55: "",
    cantidad56: "",
    cantidad57: "",
    cantidad58: "",
    cantidad59: "",
    cantidad60: "",
    cantidad61: "",
    cantidad62: "",
    cantidad63: "",
    cantidad64: "",
    cantidad65: "",
    cantidad66: "",
    cantidad67: "",
    cantidad68: "",
    cantidad69: "",
    cantidad70: "",
    cantidad71: "",
    cantidad72: "",
    cantidad73: "",
    cantidad74: "",
    cantidad75: "",
    cantidad76: "",
    cantidad77: "",
    cantidad78: "",
    cantidad79: "",
    cantidad80: "",
    cantidad81: "",
    cantidad82: "",
    cantidad83: "",
    cantidad84: "",
    cantidad85: "",
    cantidad86: "",
    cantidad87: "",
    cantidad88: "",
    cantidad89: "",
    cantidad90: "",
    cantidad91: "",
    cantidad92: "",
    cantidad93: "",
    cantidad94: "",
    cantidad95: "",
    cantidad96: "",
    cantidad97: "",
    cantidad98: "",
    cantidad99: "",
    cantidad100: "",
  });

  const actualizarProducto = (key, q) => {
   // console.log("key", key);
    //console.log("cantidad", q);
    var cantidadCambiar = 0;
    if (q || q == 0) {
      if (q == 0) {
        cantidadCambiar = form.cantidad0;
      } else if (q == 1) {
        cantidadCambiar = form.cantidad1;
      } else if (q == 2) {
        cantidadCambiar = form.cantidad2;
      } else if (q == 3) {
        cantidadCambiar = form.cantidad3;
      } else if (q == 4) {
        cantidadCambiar = form.cantidad4;
      } else if (q == 5) {
        cantidadCambiar = form.cantidad5;
      } else if (q == 6) {
        cantidadCambiar = form.cantidad6;
      } else if (q == 7) {
        cantidadCambiar = form.cantidad7;
      } else if (q == 8) {
        cantidadCambiar = form.cantidad8;
      } else if (q == 9) {
        cantidadCambiar = form.cantidad9;
      } else if (q == 10) {
        cantidadCambiar = form.cantidad10;
      }else if (q == 11) {
        cantidadCambiar = form.cantidad11;
      } else if (q == 12) {
        cantidadCambiar = form.cantidad12;
      } else if (q == 13) {
        cantidadCambiar = form.cantidad13;
      } else if (q == 14) {
        cantidadCambiar = form.cantidad14;
      } else if (q == 15) {
        cantidadCambiar = form.cantidad15;
      } else if (q == 16) {
        cantidadCambiar = form.cantidad16;
      } else if (q == 17) {
        cantidadCambiar = form.cantidad17;
      } else if (q == 18) {
        cantidadCambiar = form.cantidad18;
      } else if (q == 19) {
        cantidadCambiar = form.cantidad19;
      } else if (q == 20) {
        cantidadCambiar = form.cantidad20;
      }else if (q == 21) {
        cantidadCambiar = form.cantidad21;
      } else if (q == 22) {
        cantidadCambiar = form.cantidad22;
      } else if (q == 23) {
        cantidadCambiar = form.cantidad23;
      } else if (q == 24) {
        cantidadCambiar = form.cantidad24;
      } else if (q == 25) {
        cantidadCambiar = form.cantidad25;
      } else if (q == 26) {
        cantidadCambiar = form.cantidad26;
      } else if (q == 27) {
        cantidadCambiar = form.cantidad27;
      } else if (q == 28) {
        cantidadCambiar = form.cantidad28;
      } else if (q == 29) {
        cantidadCambiar = form.cantidad29;
      } else if (q == 30) {
        cantidadCambiar = form.cantidad30;
      }else if (q == 31) {
        cantidadCambiar = form.cantidad31;
      } else if (q == 32) {
        cantidadCambiar = form.cantidad32;
      } else if (q == 33) {
        cantidadCambiar = form.cantidad33;
      } else if (q == 34) {
        cantidadCambiar = form.cantidad34;
      } else if (q == 35) {
        cantidadCambiar = form.cantidad35;
      } else if (q == 36) {
        cantidadCambiar = form.cantidad36;
      } else if (q == 37) {
        cantidadCambiar = form.cantidad37;
      } else if (q == 38) {
        cantidadCambiar = form.cantidad38;
      } else if (q == 39) {
        cantidadCambiar = form.cantidad39;
      } else if (q == 40) {
        cantidadCambiar = form.cantidad40;
      }else if (q == 41) {
        cantidadCambiar = form.cantidad41;
      } else if (q == 42) {
        cantidadCambiar = form.cantidad42;
      } else if (q == 43) {
        cantidadCambiar = form.cantidad43;
      } else if (q == 44) {
        cantidadCambiar = form.cantidad44;
      } else if (q == 45) {
        cantidadCambiar = form.cantidad45;
      } else if (q == 46) {
        cantidadCambiar = form.cantidad46;
      } else if (q == 47) {
        cantidadCambiar = form.cantidad47;
      } else if (q == 48) {
        cantidadCambiar = form.cantidad48;
      } else if (q == 49) {
        cantidadCambiar = form.cantidad49;
      } else if (q == 50) {
        cantidadCambiar = form.cantidad50;
      }else if (q == 51) {
        cantidadCambiar = form.cantidad51;
      } else if (q == 52) {
        cantidadCambiar = form.cantidad52;
      } else if (q == 53) {
        cantidadCambiar = form.cantidad53;
      } else if (q == 54) {
        cantidadCambiar = form.cantidad54;
      } else if (q == 55) {
        cantidadCambiar = form.cantidad55;
      } else if (q == 56) {
        cantidadCambiar = form.cantidad56;
      } else if (q == 57) {
        cantidadCambiar = form.cantidad57;
      } else if (q == 58) {
        cantidadCambiar = form.cantidad58;
      } else if (q == 59) {
        cantidadCambiar = form.cantidad59;
      } else if (q == 60) {
        cantidadCambiar = form.cantidad60;
      }else if (q == 61) {
        cantidadCambiar = form.cantidad61;
      } else if (q == 62) {
        cantidadCambiar = form.cantidad62;
      } else if (q == 63) {
        cantidadCambiar = form.cantidad63;
      } else if (q == 64) {
        cantidadCambiar = form.cantidad64;
      } else if (q == 65) {
        cantidadCambiar = form.cantidad65;
      } else if (q == 66) {
        cantidadCambiar = form.cantidad66;
      } else if (q == 67) {
        cantidadCambiar = form.cantidad67;
      } else if (q == 68) {
        cantidadCambiar = form.cantidad68;
      } else if (q == 69) {
        cantidadCambiar = form.cantidad69;
      } else if (q == 70) {
        cantidadCambiar = form.cantidad70;
      }else if (q == 71) {
        cantidadCambiar = form.cantidad71;
      } else if (q == 72) {
        cantidadCambiar = form.cantidad72;
      } else if (q == 73) {
        cantidadCambiar = form.cantidad73;
      } else if (q == 74) {
        cantidadCambiar = form.cantidad74;
      } else if (q == 75) {
        cantidadCambiar = form.cantidad75;
      } else if (q == 76) {
        cantidadCambiar = form.cantidad76;
      } else if (q == 77) {
        cantidadCambiar = form.cantidad77;
      } else if (q == 78) {
        cantidadCambiar = form.cantidad78;
      } else if (q == 79) {
        cantidadCambiar = form.cantidad79;
      } else if (q == 80) {
        cantidadCambiar = form.cantidad80;
      }else if (q == 81) {
        cantidadCambiar = form.cantidad81;
      } else if (q == 82) {
        cantidadCambiar = form.cantidad82;
      } else if (q == 83) {
        cantidadCambiar = form.cantidad83;
      } else if (q == 84) {
        cantidadCambiar = form.cantidad84;
      } else if (q == 85) {
        cantidadCambiar = form.cantidad85;
      } else if (q == 86) {
        cantidadCambiar = form.cantidad86;
      } else if (q == 87) {
        cantidadCambiar = form.cantidad87;
      } else if (q == 88) {
        cantidadCambiar = form.cantidad88;
      } else if (q == 89) {
        cantidadCambiar = form.cantidad89;
      } else if (q == 90) {
        cantidadCambiar = form.cantidad90;
      }else if (q == 91) {
        cantidadCambiar = form.cantidad91;
      } else if (q == 92) {
        cantidadCambiar = form.cantidad92;
      } else if (q == 93) {
        cantidadCambiar = form.cantidad93;
      } else if (q == 94) {
        cantidadCambiar = form.cantidad94;
      } else if (q == 95) {
        cantidadCambiar = form.cantidad95;
      } else if (q == 96) {
        cantidadCambiar = form.cantidad96;
      } else if (q == 97) {
        cantidadCambiar = form.cantidad97;
      } else if (q == 98) {
        cantidadCambiar = form.cantidad98;
      } else if (q == 99) {
        cantidadCambiar = form.cantidad99;
      } else if (q == 100) {
        cantidadCambiar = form.cantidad100;
      }

      let qs = require("qs");
      let data = qs.stringify({
        cart_key: iduser,
        cart_item_key: key,
        quantity: cantidadCambiar,
        return_cart: "true",
      });
      var config = {
        method: "post",
        url: `${siteURL}${cartLinkVerCarrito}item`,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
       //   console.log(response.data);
          if (response.data) {
            swal({
              title: "Listo",
              text: "Producto Actualizado",
              icon: "success",
              button: "Aceptar",
              timer: "2200",
            });
            viewCart();
            viewTotal();
          }
        })
        .catch(function (error) {
          console.log(error);
          swal({
            title: "Error",
            text: "No se pudo Actualizar",
            icon: "error",
            button: "Aceptar",
            timer: "2200",
          });
        });

    //  console.log("cambio", cantidadCambiar);
    } else {
      //console.log("No hizo Ningun Cambio");
      swal({
        title: "Error",
        text: "No hizo Ningun Cambio",
        icon: "error",
        button: "Aceptar",
        timer: "2200",
      });
    }
  };

  const deletProduct = (key) => {
    //console.log(iduser);
   // console.log(key);
    let qs = require("qs");
    let data = qs.stringify({
      cart_key: iduser,
      cart_item_key: key,
      quantity: 0,
      return_cart: "true",
    });
    var config = {
      method: "post",
      url: `${siteURL}${cartLinkVerCarrito}item`,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
      //  console.log(response.data);
        if (response.data) {
          swal({
            title: "Listo",
            text: "Producto Eliminado",
            icon: "success",
            button: "Aceptar",
            timer: "2200",
          });
          viewCart();
          viewTotal();
        }

      })
      .catch(function (error) {
        console.log(error);
        swal({
          title: "Error",
          text: "No se pudo eliminar",
          icon: "error",
          button: "Aceptar",
          timer: "2200",
        });
      });
     

  };

  const updateFiled = (e) => {
    setState({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  //console.log(verCarrito.length);

 // console.log(verCarrito);
//  console.log(subTotalG);

  useEffect(() => {
    viewCart();
    viewTotal();
    //setNameV(0)
  }, []);
  
  
  return (
    <div>
      {!verCarrito
        ? "No hay Productos en el Carrito..."
        : verCarrito.map((item, index) => {
            let nameCantidad = "cantidad" + index;

            return (
              <div
                id={index}
                key={index}
                className="card mb-3"
                style={{ maxWidth: "540px" }}
              >
                <div className="row no-gutters">
                  <div className="col-md-4">
                    <img src={item.img} className="card-img" />
                  </div>
                  <div className="col-md-8">
                    <div className="card-body">
                      <h4 className="card-title">{ item.name }</h4>
                      <div className="card-text">
                        Cantidad:
                        <input
                          type="number"
                          id={index}
                          className="form-control col-3"
                          name={nameCantidad}
                          defaultValue={item.cantidad}
                          onChange={updateFiled}
                          min="0"
                        />
                      </div>
                    <div>
                      <div className="card-text">
                        Puntos Unitario: {item.puntos}  Precio Unitario: Q{item.precio}
                      </div>
                      <div className="card-text">
                        <small className="text-muted">
                          Total Puntos: {item.totalPuntos} Total: Q{item.total}
                        </small>
                      </div>
                      <button
                        className="btn btn-primary"
                        onClick={() => actualizarProducto(item.key, index)}
                      >
                        Actualizar
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() =>  deletProduct(item.key)}
                      >
                        Quitar
                      </button>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

     
    <div>
          <div className="container" id="totales">
          
            <div className="text-right"><b>Subtotal:</b> Q{!subTotalG ? "cargando..." : subTotalG}</div>
          </div>

            <a href="https://marykay.com.gt/carrito/"
                target="_blank"
                className="btn btn-primary"
                rel="noreferrer"
              >
                  FINALIZAR COMPRA EN LA PÁGINA
            </a>   
      </div>

  </div>
  );
}
